import { CommentsIcon, LikeIcon, LinkArrowIcon, PalyListIcon, VideoImage, ViewsIcon } from 'assets'
import { CustomModal, InstVideoPlayer, Loader } from 'components'
import { instagramPostType } from 'constant/const'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'
import { getVideoDetailsByIdAction } from 'store/action/videoReducer'
import { createImageUrl } from 'utils/createImageUrl'
import { formatNumber } from 'utils/formatNumber'
import { isVideoUrl } from 'utils/isImageOrVideo'
import { removeUtcFormate } from 'utils/removeUtcFormate'

function PostsDetails() {
   const instagramDashboardData = useSelector((state) => state.instagramDashboard)
   const { loading, postDetailsLoading, postDetails } = instagramDashboardData

   const params = useParams()
   const dispatch = useDispatch()
   const [showMore, setShowMore] = useState(false)
   const [isLongText, setIsLongText] = useState(false)
   const [openShowMoreModal, setOpenShowMoreModal] = useState(false)
   const [openVideoModal, setOpenVideoModal] = useState(false)
   const location = useLocation()

   const onCloseModal = () => {
      setOpenShowMoreModal(!openShowMoreModal)
   }

   useEffect(() => {
      if (postDetails?.caption) {
         setIsLongText(postDetails?.caption.length > 250)
      }
      return () => {}
   }, [postDetails])

   // useEffect(() => {
   //    if (loadMoreComments) {
   //       dispatch(
   //          getVideoDetailsByIdAction({ channel_id: selectedChannelID, video_id: params?.id })
   //       )
   //    }
   //    return () => {}
   // }, [loadMoreComments])

   const onCloseVideoModal = () => {
      setOpenVideoModal(false)
   }

   return (
      <div>
         {(postDetailsLoading || loading) && (
            <Loader message={location.state?.loadingMessage || ''} />
         )}
         <div className="card">
            <div className="video-details-section">
               <div className="row">
                  <div className="col-lg-3">
                     <div
                        className="video-image in-video-image"
                        onClick={() => {
                           postDetails?.media_type === instagramPostType.VIDEO &&
                              setOpenVideoModal(true)
                        }}>
                        {postDetails?.media_type === instagramPostType.VIDEO ? (
                           // postDetails?.thumbnail_url ? (
                           //    <img
                           //       src={createImageUrl(postDetails?.thumbnail_url)}
                           //       alt="InPostImage"
                           //       className="mw-100"
                           //    />
                           // ) : (
                           //    <video
                           //       src={postDetails?.media_url}
                           //       autoPlay={false}
                           //       preload="auto"
                           //       sty></video>
                           // )
                           postDetails?.thumbnail_url ? (
                              isVideoUrl(postDetails?.thumbnail_url) ? (
                                 <video
                                    src={createImageUrl(postDetails?.thumbnail_url)}
                                    autoPlay={false}
                                 />
                              ) : (
                                 <img
                                    src={createImageUrl(postDetails?.thumbnail_url)}
                                    alt="InPostImage"
                                    className="mw-100"
                                 />
                              )
                           ) : (
                              <video src={postDetails?.media_url} autoPlay={false} />
                           )
                        ) : (
                           <>
                              <img
                                 src={postDetails?.media_url}
                                 alt="InPostImage"
                                 className="mw-100"
                              />
                           </>
                        )}
                     </div>
                  </div>
                  <div className="col-lg-9">
                     <div className="video-desc">
                        <div className="video-name-section">
                           <div className="video-name-wrap">
                              {/* <h3 className="at-text-dark">{videoDetailsData?.title}</h3> */}
                              <p
                                 className="at-text-light"
                                 style={{ fontSize: '12px', color: '#FF423D' }}>
                                 {postDetails?.timestamp
                                    ? dayjs(removeUtcFormate(postDetails?.timestamp)).format(
                                         'D MMMM, YYYY'
                                      )
                                    : ''}
                              </p>
                           </div>
                           <div
                              className="channel-btn"
                              onClick={() => {
                                 window.open(postDetails?.permalink)
                              }}>
                              <span>View Post</span>
                              <LinkArrowIcon />
                           </div>
                        </div>
                        <p
                           className="mt-2 at-text-light"
                           style={{ fontWeight: '400', whiteSpace: 'pre-wrap' }}>
                           {(postDetails?.caption && showMore) || !isLongText ? (
                              postDetails?.caption
                           ) : (
                              <>
                                 {postDetails?.caption.substring(0, 150)}
                                 <span
                                    className="show-more-text"
                                    onClick={() => {
                                       setOpenShowMoreModal(true)
                                    }}>
                                    ...Show more
                                 </span>
                              </>
                           )}
                        </p>
                        <div className="channel-counter mt-3">
                           <div className="row">
                              <div className="col-12 col-lg-4">
                                 <div className="channel-count-wrap">
                                    <div className="count-logo">
                                       <ViewsIcon />
                                    </div>
                                    <div className="counter-desc">
                                       <div>
                                          <p className="at-text-dark">
                                             {formatNumber(postDetails?.view_count || 0, 2)}
                                          </p>
                                          <span className="at-text-light">VIEWS</span>
                                       </div>
                                       {/* <div className="counter-per">+5,9%</div> */}
                                    </div>
                                 </div>
                              </div>
                              <div className="col-12 col-lg-4">
                                 <div className="channel-count-wrap">
                                    <div className="count-logo">
                                       <CommentsIcon />
                                    </div>
                                    <div className="counter-desc">
                                       <div>
                                          <p className="at-text-dark">
                                             {formatNumber(postDetails?.comment_count || 0, 2)}
                                          </p>
                                          <span className="at-text-light">COMMENTS</span>
                                       </div>
                                       {/* <div className="counter-per">+5,9%</div> */}
                                    </div>
                                 </div>
                              </div>
                              <div className="col-12 col-lg-4">
                                 <div className="channel-count-wrap">
                                    <div className="count-logo">
                                       <LikeIcon />
                                    </div>
                                    <div className="counter-desc">
                                       <div>
                                          <p className="at-text-dark">
                                             {' '}
                                             {formatNumber(postDetails?.like_count || 0, 2)}
                                          </p>
                                          <span className="at-text-light">LIKES</span>
                                       </div>
                                       {/* <div className="counter-per">+5,9%</div> */}
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         {openVideoModal && (
            <InstVideoPlayer
               onClose={onCloseVideoModal}
               openVideoModal={openVideoModal}
               url={postDetails?.media_url}
            />
         )}
         {openShowMoreModal && (
            <CustomModal
               show={openShowMoreModal}
               title={'Description'}
               closeModal={onCloseModal}
               centered
               scrollable
               size={'lg'}>
               <div style={{ whiteSpace: 'pre-wrap' }}>{postDetails?.caption}</div>
            </CustomModal>
         )}
      </div>
   )
}

export default PostsDetails
